/* eslint-disable unicorn/prefer-array-some */
/**
 * V2 dimensional table helpers — progressive metadata + block outputs loading.
 * Re-exports shared helpers from TableHelpersOpz; only row building differs.
 */
import { blockOutputDisplayText } from 'utils/scaleBlockOutputPercentageValues';

import { dimensionalFooterRow, dimensionalHeaderRow } from './TableHelpersOpz';

export {
  buildTree,
  getDimensionalColumns,
  getColumns,
  reorderArray,
  getExpandedRows,
  handleCellChange,
  handleColumnResize,
  handleLocationChanged,
  handleCanReorderRows,
  dimensionalHeaderRow,
  dimensionalFooterRow,
} from './TableHelpersOpz';

export const buildDimensionalDataTableItemRowV2 = (
  item: any,
  tableProperty_: any[],
  tableItemsLength: number,
  index: number,
  modelCurrency?: string,
  valuesLoading = false,
) => {
  const buildCells = (rowItem: any, rowIndex: number, properties: any[], currency?: string) => {
    const nameCell = {
      type: rowItem?.chevronType ? 'chevron' : 'text',
      isExpanded: false,
      hasChildren: rowItem?.chevronType,
      parentId: rowItem?.parentId,
      placeholder: 'Enter value',
      currencyType: currency,
      text: rowItem?.name ?? '',
      property: 'name',
      rows: tableItemsLength,
      hasFormulaError: rowItem?.warning?.length > 0,
      hasFormulaErrorMessage: rowItem?.warning,
      className: `name ${rowItem?.parentId ? 'chevron-child' : ''} ${
        rowItem?.warning?.length > 0 ? 'formula-error ' : ''
      }`,
      isNewCell: !!rowItem?.isNewCell,
      indicatorType: rowItem?.indicator_type,
      nonEditable: !!rowItem?.parentId,
      index: rowIndex,
      ...rowItem?.cellData,
    };

    const valueCells = properties?.map((data: any, index_: number) => {
      const value = rowItem?.total_values?.find((data_: any) => data_?.name === data?.name);
      const showValueLoading = valuesLoading && !rowItem?.isNewCell;
      return {
        type: 'text',
        isNewCell: !!rowItem?.isNewCell,
        rows: tableItemsLength,
        text: showValueLoading
          ? ''
          : rowItem?.isNewCell
          ? '0'
          : value
          ? blockOutputDisplayText(value?.value, rowItem?.type)
          : '0',
        isLoading: showValueLoading,
        format: rowItem?.type,
        tableName: 'block',
        currencyType: currency,
        index: rowIndex,
        data,
        nonEditable: true,
        className: `${showValueLoading ? 'block-table-cell-loading ' : ''}${
          rowItem?.parentId ? ' chevron-child ' : ''
        } ${index_ === (properties?.length ?? 0) - 1 ? ' last-index ' : ''} ${
          rowItem?.warning?.length > 0 ? 'formula-error ' : ''
        } ${data?.isActual ? 'actuals-cell' : ''}`,
        hasFormulaError: false,
      };
    });

    const deleteCell = {
      type: 'dropdown',
      buttonType: 1,
      currencyType: currency,
      selectOption: false,
      className: `${rowItem?.warning?.length > 0 ? 'formula-error' : ''}`,
      id: rowItem?.id,
      itemName: rowItem?.name,
      nonEditable: !rowItem?.id && !rowItem?.indicatorId,
      values: [{ label: 'Delete row', value: '' }],
    };

    return [nameCell, ...(valueCells || []), deleteCell];
  };

  return {
    rowId: item?.id ?? `${item?.name}_${item?.id ?? item?.parentId}`,
    height: 40,
    itemId: item?.id ?? item?.indicatorId,
    itemName: item?.name,
    reorderable: !item?.parentId,
    isNewCell: !!item?.isNewCell,
    cells: buildCells(item, index, tableProperty_, modelCurrency),
  };
};

export const getDimensionalRowsV2 = (
  tableItemsProperty_: any[],
  tableProperty_: any[],
  modelCurrency?: string,
  valuesLoading = false,
) => {
  const headerRow = dimensionalHeaderRow(tableProperty_);
  const footerRow = dimensionalFooterRow(tableProperty_);

  const processItems = (items: any[]) => {
    return items.map((item: any, index: number) =>
      buildDimensionalDataTableItemRowV2(
        item,
        tableProperty_,
        tableItemsProperty_?.length ?? 0,
        index,
        modelCurrency,
        valuesLoading,
      ),
    );
  };

  return [
    headerRow,
    ...(tableItemsProperty_?.length ? processItems(tableItemsProperty_) : []),
    footerRow,
  ];
};
